import "../img/giving-back/marysmeals.png";
import "../img/giving-back/marysmeals-small.png";
import "../img/giving-back/marysmeals-large.png";

import "../img/giving-back/hullheroes.png";
import "../img/giving-back/hullheroes-small.png";
import "../img/giving-back/hullheroes-large.png";
